import createMark from '../../internal/createMark';
export const AppContainerMounted = createMark('appContainerRender');
export const AppRenderApplicationStart = createMark('app-renderApplication-start');
export const AppStart = createMark('app-start-start');
export const BeginningOfTime = createMark(undefined);
export const HTMLEnd = createMark('html-end');
export const HTMLStart = createMark('html-start');
export const Now = createMark(undefined);